// Booking-box funnel events. Every event carries car_id + service mode.
// Never include raw addresses, coordinates or other PII here.
export type ServiceMode = "self_drive" | "chauffeur" | "event";

export function serviceModeFor(tab: "driving" | "chauffeured" | "event"): ServiceMode {
  return tab === "driving" ? "self_drive" : tab === "chauffeured" ? "chauffeur" : "event";
}

export type BookingBoxEvent =
  | "booking_date_selected"
  | "booking_duration_selected"
  | "location_prefilled"
  | "location_changed"
  | "location_error";

export function bookingBoxProps(carId: number, tab: "driving" | "chauffeured" | "event", extra: Record<string, unknown> = {}) {
  const serviceMode = serviceModeFor(tab);
  // `mode` is the requested two-bucket funnel (chauffeur | self_drive):
  // event bookings use the same hourly box, so they count as chauffeur there
  // and stay distinguishable through service_mode / rental_type = event.
  const mode = tab === "driving" ? "self_drive" : "chauffeur";
  return { car_id: carId, mode, service_mode: serviceMode, rental_type: tab, ...extra };
}

export function trackBookingBox(event: BookingBoxEvent, carId: number, tab: "driving" | "chauffeured" | "event", extra: Record<string, unknown> = {}) {
  // Self-drive keeps its existing interaction and location flow, but its date
  // selections belong in the explicitly requested two-mode date funnel.
  if (tab === "driving" && event !== "booking_date_selected") return;
  void import("@/lib/analytics")
    .then(({ track }) => track(event as never, bookingBoxProps(carId, tab, extra) as never))
    .catch(() => {});
}
